import { Api } from "@/services/configs/axios";
import { AxiosPromise } from "axios";

export class ExternalMapService {
  getFilterItems = (
  ): AxiosPromise<any> => Api.get('map/filtro');
  postFilterItems = (data: any) => Api.post("map/dados", data);
  getTooltipItem = (data: any) => Api.post("map/tooltip", data);
}
